import { ComponentClass, createElement, FunctionComponent, memo, NamedExoticComponent, RefObject } from "react";
import classNames from "classnames";
import { ScrollEventCallback } from "overlayscrollbars";
import { getPortalComponents } from "../../../../../generic";
import { Scrollbars } from "../../../../../ui";
import { ArrowBtn } from "./ArrowBtn";

import { ReactComponent as LeftArrow } from "./icons/leftArrow.svg";
import { ReactComponent as RightArrow } from "./icons/rightArrow.svg";

import styles from "./style.module.scss";

const { Container, PortalContentProvider } = getPortalComponents();
export const TabHeaderButton = PortalContentProvider;

export type TabsHeadersContainerProps = {
  tabsRef?: RefObject<any> | null,
  onScroll?: ScrollEventCallback,
  disabledRightArrow: boolean,
  disabledLeftArrow: boolean,
  onArrowClick: (direction: string) => void,
  className?: string
  tabsContainerClassName?: string,
  containerComponent?: string | FunctionComponent | ComponentClass | NamedExoticComponent
}

export const TabsHeadersContainer = memo<TabsHeadersContainerProps>((
  {
    onScroll,
    tabsRef,
    disabledRightArrow,
    disabledLeftArrow,
    onArrowClick,
    className,
    tabsContainerClassName,
    containerComponent = Container,
  }) => {

  return (
    <div className={classNames(styles.container, className)}>
      <ArrowBtn icon={LeftArrow} disable={disabledRightArrow} onClick={() => onArrowClick("right")} />
      <Scrollbars
        options={{
          sizeAutoCapable: false,
          overflowBehavior: {
            y: "hidden",
          },
          scrollbars: {
            visibility: "hidden",
          },
          callbacks: {
            onScroll: onScroll,
          },
        }}
        ref={tabsRef}
      >
        {createElement(containerComponent, { className: classNames(styles.tabsContainer, tabsContainerClassName) } as any)}
      </Scrollbars>
      <ArrowBtn icon={RightArrow} disable={disabledLeftArrow} onClick={() => onArrowClick("left")} />
      <div className={styles.borderBackgroundFix} />
    </div>
  );
});
